import { Close, RocketLaunch, TaskAlt } from '@mui/icons-material';
import { Box, Button, IconButton, LinearProgress, List, ListItem, ListItemButton, ListItemText, SwipeableDrawer } from '@mui/material';
import { useContext } from 'react';
import { ToolContext } from '../../../../../../core/context/ToolContext';
import { useEffect } from 'react';
import { useState } from 'react';
import { rqx } from '../../../../../../core/request/API';
import { env } from '../../../../../../core/Env';

const StartHere = () => {
    const {tool_state} = useContext(ToolContext)
    const { __SESSION, personalization } = tool_state

    const [taskStatus, setTaskStatus] = useState(null)
    const [progressValue, setProgressValue] = useState(0)

    const user_id = window.atob(__SESSION.data.ainfo.aid).slice(8)   

    const task = [
        {label: 'Coment', description: 'Coment atleast 1 in Article, News, Updates', status: taskStatus?.comment, path: '/psl/publication?tab=article', action: ''},
        {label: 'Like', description: 'Like atleast 1 in Article, News, Updates', status: taskStatus?.reaction, path: '/psl/publication?tab=article', action: ''},
        {label: 'Save', description: 'Save atleast 1 in Article, News, Updates', status: taskStatus?.save, path: '/psl/publication?tab=article', action: ''},
        {label: 'Read', description: 'Read atleast 1 in Article, News, Updates', status: taskStatus?.views, path: '/psl/publication?tab=article', action: ''},
    ]
    
    const openHandler = () => {
        personalization.set(prev => ({...prev, startHere: true}))
    }

    const closeHandler = () => {
        personalization.set(prev => ({...prev, startHere: false}))
    }

    const __runTask = async () => {
        let data = await rqx.get(`<<tool>>/${env()}/psl/start/read`, {user_id: user_id})
        setTaskStatus(data)
    }
    
    const calculateProgress = ()=>{
        const taskDone = task.filter(v => v.status === 'done')
        setProgressValue(taskDone.length / task.length * 100)
    }

    useEffect(() => {
        __runTask()
       calculateProgress()
        // eslint-disable-next-line
    }, [personalization.data.startHere])
    
    return task.filter(v => v.status === 'proceed').length > 0 ? (
        <Box>
            <Button
                onClick={() => openHandler()}
                disableElevation
                variant='contained'
                sx={{
                    position: 'absolute',
                    right: 15, 
                    bottom: 75,
                    background: '#453FBA !important',
                    color: '#fff',
                    borderRadius: '100px',
                    padding: '12px 16px',
                }}
                startIcon={<RocketLaunch />}
            >
                Start Here
            </Button>

        <SwipeableDrawer
            anchor="bottom"
            open={personalization.data.startHere}
			onClose={() => closeHandler()}
            onOpen={() => closeHandler()}
			PaperProps={{sx:{borderRadius:'12px 12px 0px 0px'}}}
        >
            <Box display="flex" flexDirection="column" gap="16px" p="20px 16px">
                <Box display="flex" flexDirection="column" gap="12px">
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Box fontSize="16px" fontWeight="600">Stsrt here</Box>
                        <IconButton onClick={() => closeHandler()} sx={{p: '8px'}}>
                            <Close sx={{fontSize: '18px'}}/>
                        </IconButton>
                    </Box>
                    <Box fontSize="14px">Complete these steps to unlock all the benefits and get the most out of Philtaxes.</Box>
                </Box>
                <Box display="flex" alignItems="center" gap="12px" >
                    <Box fontSize="16px" fontWeight="600">{`${progressValue}%`}</Box>
                    <LinearProgress
                        variant="determinate"
                        value={progressValue}
                        sx={{
                            width: '100%',
                            height: 8,
                            borderRadius: 10,
                            background: '#E7E8EA',
                            [`& .MuiLinearProgress-bar`]: {
                                borderRadius: 10,
                                background: '#453FBA'
                            }
                        }}
                    />
                </Box>
                <List disablePadding>
                    {
                        task.map((v, i) => (
                            <ListItem
                                key={i}
                                sx={{background: '#FBFCFB', my: '4px'}}
                                secondaryAction={ 
                                    v.status === 'proceed' ? 
                                        <Button onClick={() => closeHandler()} disableElevation sx={{background: '#E7E8EA', borderRadius: '4px', fontSize: '12px', color: '#292C2F', '&:hover':{background: '#E7E8EA'}}}>
                                            Proceed
                                        </Button>
                                    :
                                        <Box display="flex" alignItems="center" gap="8px">
                                            <Box fontSize="12px" color="#22A06B">Done</Box>
                                            <TaskAlt sx={{color: '#22A06B', fontSize: '18px'}}/>
                                        </Box>
                                }
                                disablePadding
                            >
                                <ListItemButton sx={{py: '10px', borderRadius: '6px'}}>
                                    <ListItemText 
                                        primary={<Box fontSize="12px">{v.label}</Box>}
                                    />
                                </ListItemButton>
                            </ListItem>
                        ))
                    }
                </List>
            </Box>
        </SwipeableDrawer>
        </Box>
    ) : null
}

export default StartHere;